import React, { Component } from "react";
import { Link } from "react-router-dom";

class Breadcrumb extends Component {
  scrollTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  render() {
    const base = process.env.PUBLIC_URL || "";
    return (
      <div className="hn-breadcrumb">
        <h1>About Us</h1>
        <nav className="hn-breadcrumb-nav">
          <Link to={`${base}/`} onClick={this.scrollTop}>Home</Link>
          <i className="bi bi-chevron-right" />
          <span>About Us</span>
        </nav>
      </div>
    );
  }
}

export default Breadcrumb;
